<template>
  <div v-for="opt in specificOptions" :key="opt.id" class="pe-option-container">

    <label v-if="shouldShowLabel(opt)" :class="[globalConfig.classes?.label]">
      {{ opt.title }}
    </label>

    <div v-if="isTextarea(opt)">
      <RichTextEditor :class="[opt.value ? globalConfig.classes?.input : globalConfig.classes?.placeholder]"
        :modelValue="opt.value || ''" @update:modelValue="(val) => handleTextareaInput(opt, { target: { value: val } })"
        :placeholder="opt.description"
        @upload-error="(name) => globalConfig.toasts?.error?.(`Error subiendo ${name}`)" />
    </div>

    <PeInpunt v-else :type="getInputType(opt)" :model-value="opt.value"
      @update:model-value="(val) => setAnswer(opt.id, val)" :placeholder="opt.description"
      :class="[opt.value ? globalConfig.classes?.input : globalConfig.classes?.placeholder]" />

    <span v-if="opt.error" :class="['pe-error-msg', globalConfig.classes?.optionError]">{{ opt.error }}</span>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import RichTextEditor from '../Shared/RichTextEditor.vue';
import PeInpunt from '../Shared/PeInpunt.vue';

const props = defineProps({
  question: { type: Object, required: true },
  groupType: { type: String, required: true }
});

const engine = inject('formEngine');
const globalConfig = inject('engineConfig');

// 1. EXTRAEMOS SOLO EL GRUPO QUE NOS TOCA
const specificOptions = computed(() => {
  // Accedemos directo al grupo usando la prop.
  // Ej: si groupType es 'number', solo traemos los numbers.
  return props.question.optionGroups[props.groupType] || [];
});

const shouldShowLabel = (opt) => {
  // Mostramos label si hay más de 1 input en este grupo (ej: Nombre y Apellido)
  // O si la configuración de la opción lo pide explícitamente (show_title)
  return specificOptions.value.length > 1 || opt.show_title;
};

const isTextarea = (opt) => opt.type === 'textarea';

const getInputType = (opt) => {
  return opt.type || 'text';
};

const setAnswer = (optId, value) => {
  engine.setAnswer(props.question.id, optId, value);
};

const handleTextareaInput = (opt, event) => {
  const target = event.target;
  setAnswer(opt.id, event.target.value);
  // solo ajustar altura si es elemento html nativo
  if (target.style) {
    target.style.height = 'auto';
    target.style.height = `${target.scrollHeight}px`;
  }
};
</script>

<style scoped>
.input-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>